export default String.raw`
.check-deliveries {
    min-width: 500px;
    max-width: 520px;
    max-height: 476px;

    .dialog {
        &__content {
            padding: 24px 32px 32px 32px;
            gap: 24px;
            align-items: flex-start;

            .product {
                display: flex;
                align-items: center;
                gap: 16px;
                align-self: stretch;

                &__image {
                    max-width: 100%;
                    height: auto;
                    max-height: 100%;
                    object-fit: contain;

                    &-wrapper {
                        width: 60px;
                        height: 60px;
                        aspect-ratio: 1;
                        border-radius: 4px;
                        align-content: center;
                    }
                }

                &__name {
                    @include body-1-medium;
                }
            }
        }

        &__actions {
            padding: 0 0 32px 0;
            width: 100%;
            justify-content: center;
        }
    }

    &__table {
        width: 100%;
        border-collapse: separate; 
        display: block;
        overflow: auto;

        .table {    
            &__cell {
                border-bottom: 1px solid rgba(227, 227, 250, 0.50);
                padding: 8px 16px 8px 0;
                @include body-2-regular;

                &:last-child {
                    padding: 8px 0;
                    text-align: right !important;
                }

                &.date {
                    @include body-2-semibold;
                }
            }
    
            &__head {
                .table__cell {
                    position: sticky;
                    z-index: 1;
                    top: 0;
                    background: #ffffff;
                    @include body-2-medium;
                }
            }
        }
    }

    &__not-ordered {
        @include body-1-regular;
    }

    &__more-info {
        @include body-1-regular;
    }
}

//State:
.check-deliveries-popup-js:has(.check-deliveries-table-content-js:not(:empty)) .not-ordered-js {
    display: none;
}

.check-deliveries-popup-js:has(.check-deliveries-table-content-js:empty) .check-deliveries-table-js {
    display: none;
}

.check-deliveries-popup-js:has(.check-deliveries-table-content-js:empty) .more-info-js {
    display: none;
}
`